import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./ContactSection.scss";
import emil from "../../../src/Assets/mail.png"
import call from "../../../src/Assets/call.png"
import location from "../../../src/Assets/location_on.png"
import PatientAppBar from "../PatientAppBar/PatientAppBar";
import { CONTACT_HERO_BODY } from "../../content/landingContent";

export default function ContactSection({ showHero = true }) {
    const { state } = useLocation();
    const patientBack = state?.patientBack;

    return (
        <div className="hcWrap ">
            {patientBack ? (
              <PatientAppBar
                title="Contact"
                subtitle="Reach the team"
                backTo={patientBack.to}
                backLabel={patientBack.label || "Back"}
              />
            ) : null}
            {showHero ? (
            <div className="contactback">
                <div className="container">
                    <section className="hcHero">
                        <div className="hcHeroInner">
                            <h1>Take control of your healthcare</h1>
                            <p>{CONTACT_HERO_BODY}</p>

                            <div className="hcHeroBtns">
                                <Link to="/get-started" className="hcBtnPrimary">
                                    Start now
                                </Link>
                                <Link to="/AboutUs" className="hcBtnGhost">
                                    Learn more
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            ) : null}

                   {/* ===== CONTACT ===== */}
            <div className="container">
                <section className="hcContact">
                <div className="hcContactInner">
                    {/* LEFT */}
                    <div className="hcLeft">
                        <div className="hcMiniTitle"><p>Connect</p></div>
                        <div className="hcBigTitle"><p>Get in touch</p></div>
                        <div className="hcSub">
                            <p>We&apos;re here to help you compare surgery prices and book with confidence</p>
                        </div>

                        <div className="hcInfoList">
                            {/* Email */}
                            <div className="hcInfoItem">
                                <span><img src={emil} alt="" /></span>
                                <div className="hcInfoText">
                                    <div className="hcInfoHead">Email</div>
                                    <div className="hcInfoDesc">Send us a message anytime</div>
                                    <a className="hcLink" href="mailto:support@healthcarehealbid.com">
                                        support@healthcarehealbid.com
                                    </a>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="hcInfoItem">
                                <span><img src={call} alt="" /></span>
                                <div className="hcInfoText">
                                    <div className="hcInfoHead">Phone</div>
                                    <div className="hcInfoDesc">Talk to our support team</div>
                                    <a className="hcLink" href="tel:+18444327849">
                                        +1 (844) 432-7849
                                    </a>
                                </div>
                            </div>

                            {/* Office / registered address */}
                            <div className="hcInfoItem">
                                <span><img src={location} alt="" /></span>
                                <div className="hcInfoText">
                                    <div className="hcInfoHead">Mailing &amp; legal</div>
                                    <div className="hcInfoDesc">
                                        For registered business address, tax IDs, or contracts, email or call — we provide official details on request.
                                    </div>

                                    <a className="hcDirections" href="mailto:support@healthcarehealbid.com?subject=Registered%20address%20request">
                                        Request details <span className="hcArr">›</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT (Dummy map now, later API) */}
                    <div className="hcRight">
                        <div className="hcMapCard" role="img" aria-label="map placeholder">
                            <div className="hcMapOverlay">
                                <div className="hcPin p1">+</div>
                                <div className="hcPin p2">+</div>
                                <div className="hcPin p3">+</div>
                            </div>

                            <div className="hcMapLabels">
                                <div className="hcMapLabel l1">KORAMANGALA</div>
                                <div className="hcMapLabel l2">Bellandur Lake</div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            </div>
        </div>
    );
}